export class Step9 {
    constructor() {}
    intitule = 'stepper.form.simp_re.step9';
    infosRectif = 'form.simp_re.getinfosrectif';

    getspan6 = 'form.simp_re.getspan6';
    getspan6_1 = 'form.simp_re.getspan6_1';
    getspan68 = 'form.simp_re.getspan68';
    getrubdelais = 'form.simp_re.getrubdelais';
    getspan7 = 'form.simp_re.getspan7';
    getliredate = 'form.simp_re.getliredate';
    getspan8 = 'form.simp_re.getspan8';
    getspan8_1 = 'form.simp_re.getspan8_1';
    getrubrique = 'form.simp_re.getrubrique';
    getapreslamention = 'form.simp_re.getapreslamention';
    getaulieude = 'form.simp_re.getaulieude';
    getajouter = 'form.simp_re.getajouter';
    getlire = 'form.simp_re.getlire';
    getsupprimer = 'form.simp_re.getsupprimer';
    getinfoRectificative = 'form.simp_re.getinfoRectificative';
    ajouter = 'boutons.ajouter';
    supprimer = 'boutons.supprimer';
    ajouterInfoRectif = 'boutons.ajouterInfoRectif';
    

}
